export default function LoadingSpinner({ size = 'md', message }) {
  const sizes = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-3',
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12">
      <div
        className={`animate-spin rounded-full border-gray-200 border-t-blue-600 ${sizes[size] || sizes.md}`}
      />
      {message && <p className="text-sm text-gray-500">{message}</p>}
    </div>
  );
}
